import React from 'react';
import { useIntl } from 'react-intl';

import { usePaths } from '../../../routes/routesHelper';
import { PAStyledLinkNoUnderline } from '../../ui';
import { FooterTextWrapper } from './styles';

type Props = {
  projectId: string;
};

const Footer = ({ projectId }: Props): JSX.Element => {
  const { userAttributesPath } = usePaths();
  const intl = useIntl();

  return (
    <FooterTextWrapper>
      {intl.formatMessage(
        { id: 'users.attributes.table.schema-link' },
        {
          a: (chunk: string) => (
            <PAStyledLinkNoUnderline to={userAttributesPath(projectId)}>
              {chunk}
            </PAStyledLinkNoUnderline>
          )
        }
      )}
    </FooterTextWrapper>
  );
};

export default Footer;
